export default {"src":"/_next/static/media/2.4565d766.svg","height":20,"width":9,"blurWidth":0,"blurHeight":0};